export default function DangerButton({buttonText, clickHandler}) {

	return (
		<>
			<button type="button" onClick={clickHandler} className="btn btn-danger m-5">
				{buttonText}
			</button>
		</>
	);
}